<template>
  <!-- AI F §1.2.5 — Edit metadata -->
  <div class="p-8">
    <woot-modal-header
      :header-title="$t('KNOWLEDGE_BASE.RENAME.TITLE')"
      :header-content="$t('KNOWLEDGE_BASE.RENAME.DESC')"
    />

    <form class="mt-4" @submit.prevent="submit">
      <label>
        {{ $t('KNOWLEDGE_BASE.RENAME.NAME') }}
        <input v-model="name" type="text" />
      </label>

      <div class="flex justify-end gap-2">
        <woot-button variant="clear" @click.prevent="$emit('close')">
          {{ $t('KNOWLEDGE_BASE.RENAME.CANCEL') }}
        </woot-button>
        <woot-button
          type="submit"
          :is-loading="isSaving"
          :is-disabled="!name.trim() || isSaving"
        >
          {{ $t('KNOWLEDGE_BASE.RENAME.SAVE') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    source: {
      type: Object,
      required: true,
    },
  },
  data() {
    return { name: this.source.name || '', isSaving: false };
  },
  methods: {
    // AI F §1.2.5, §1.2.6
    async submit() {
      this.isSaving = true;
      try {
        await this.$store.dispatch('kbSources/update', {
          id: this.source.id,
          name: this.name.trim(),
        });
        this.showAlert(this.$t('KNOWLEDGE_BASE.RENAME.SAVED'));
        this.$emit('close');
      } catch (error) {
        this.showAlert(
          error?.response?.data?.error || this.$t('KNOWLEDGE_BASE.RENAME.ERROR')
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
